export default {
  state: {
    isOpenFilter: {
      brand: false,
      rating: false,
      sorting: false,
      userLevel: false,
      skinType: false,
    },
    browseBy: {
      brand: false,
    },
  },
  mutations: {
    setFilterProduct(state, { filterName, value }) {
      state.isOpenFilter[filterName] = value;
    },
    setBrowseBy(state, { type, value }) {
      state.browseBy[type] = value;
    },
  },
};
